import { useState, useEffect, useCallback } from 'react';

const PING_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/health`
  : 'http://localhost:8080/health';

export function useNetworkStatus() {
  const [status, setStatus] = useState('connected'); // connected | degraded | offline

  const ping = useCallback(async () => {
    if (!navigator.onLine) {
      setStatus('offline');
      return;
    }
    try {
      const res = await fetch(PING_URL, { method: 'GET', signal: AbortSignal.timeout(3000) });
      setStatus(res.ok ? 'connected' : 'degraded');
    } catch {
      setStatus(navigator.onLine ? 'degraded' : 'offline');
    }
  }, []);

  useEffect(() => {
    ping();
    const interval = setInterval(ping, 15000);
    window.addEventListener('online', ping);
    window.addEventListener('offline', () => setStatus('offline'));
    return () => {
      clearInterval(interval);
      window.removeEventListener('online', ping);
      window.removeEventListener('offline', () => setStatus('offline'));
    };
  }, [ping]);

  return status;
}
